<template>
  <div class="product-details-content-draggable-modules">
    <draggable
      :value="value"
      @input="val => $emit('input', val)"
      handle=".handle"
      :group="group"
    >
      <draggable-modules-item
        class="mb-5"
        v-for="(item, index) in value"
        :key="index"
        :module="item"
        @edit="getEditAction"
        @duplicate="getDuplicateAction"
        @remove="getRemoveAction"
      />
    </draggable>
  </div>
</template>

<script>
import DraggableModulesItem from "@/components/product/details/content/DraggableModulesItem.vue";
import draggable from "vuedraggable";

export default {
  name: "draggable-modules",
  components: { draggable, DraggableModulesItem },
  props: {
    value: Array,
    hideSubModules: Boolean,
    group: { type: String, default: "modules" }
  },
  methods: {
    getEditAction(item) {
      let type = "edit-module";

      if (item?.type == "lesson") {
        type = "edit-lesson";
      }

      if (item?.type == "submodule") {
        type = "edit-submodule";
      }

      if (item?.type == "quiz") {
        type = "edit-quizz";
      }

      this.$emit(type, item);
    },
    getDuplicateAction(item) {
      let type = "duplicate-module";

      if (item?.type == "lesson") {
        type = "duplicate-lesson";
      }

      if (item?.type == "submodule") {
        type = "duplicate-submodule";
      }

      if (item?.type == "quiz") {
        type = "duplicate-quizz";
      }

      this.$emit(type, item);
    },
    getRemoveAction(item) {
      let type = "remove-module";

      if (item?.type == "lesson") {
        type = "remove-lesson";
      }

      if (item?.type == "submodule") {
        type = "remove-submodule";
      }

      if (item?.type == "quiz") {
        type = "remove-quizz";
      }

      this.$emit(type, item);
    }
  }
};
</script>
